var BaseViews = require('../common/base');
var Moment = require('moment');
require('./root/root.scss');
var FooterRootView = BaseViews.LayoutView.extend({
  className: 'fmcy-footer-root-view',
  template: require('./root/root.html'),
  initialize: function(options) {
      var self = this;
      this.options = _.defaults(
          options || {},
          {
              _appChannel: null
          }
      );
  },
  regions: {
    locationListRegion: '#farmacy-location-list-region',
    brandingRegion: '#farmacy-footer-branding-region'
  },
  serializeData: function () {
    return {
      rootUrl: window.location.protocol + '//' + window.location.hostname,
      year: moment().format('YYYY')
    }
  }
});

module.exports = FooterRootView;



/** WEBPACK FOOTER **
 ** ./assets/js/footer-app/root.js
 **/